<template>
  <div class="authentication-wrapper authentication-3">
    <div class="authentication-inner">
      <!-- Side container -->
      <!-- Do not display the container on extra small, small and medium screens -->
      <div
        class="d-none d-lg-flex col-lg-8 col-xl-9 align-items-center ui-bg-cover ui-bg-overlay-container p-5"
        :style="`background-image: url('/img/bg/21.jpg');`"
      >
        <div class="ui-bg-overlay bg-dark opacity-50"></div>

        <!-- Text -->
        <div class="w-100 text-white px-5">
          <h1 class="display-2 font-weight-bolder mb-4">JOIN OUR<br />COMMUNITY</h1>
          <div class="text-large font-weight-light">
            Bring your office floor plans to life by signing up for the online version of Floor Plan Mapper. <br />
            Floor Plan Mapper transforms your office floor plans into an interactive, dynamic, clickable office employee map.
            <br />Search and locate employees and meeting rooms.
          </div>
        </div>
        <!-- /.Text -->
      </div>
      <!-- / Side container -->

      <!-- Form container -->
      <div class="d-flex col-lg-4 col-xl-3 align-items-center bg-white p-5">
        <!-- Inner container -->
        <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
        <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
          <div class="w-100">
            <!-- Logo -->
            <div class="d-flex justify-content-center align-items-center">
              <div class="w-100 position-relative text-center">
                <img src="/img/logo.png" alt="Floor Plan Mapper" />
              </div>
            </div>
            <!-- / Logo -->
            <router-view />
          </div>
        </div>
      </div>
      <!-- / Form container -->
    </div>
  </div>
</template>

<style src="@/assets/appwork/pages/authentication.scss" lang="scss"></style>

<script>
export default {
  name: 'auth'
}
</script>

<style scoped></style>
